import { CircleLoader, PageHeader } from 'components';
import { Dashboard, Filters, MobileFilters, MobileResults, Queues, Results } from './components';
import { ticketsContext } from './TicketsContext';
import { useContext } from 'react';
import { appUserContext } from 'helpers/services';
import { colors, Grid } from '@mui/material';
import { TicketQueues } from 'helpers/Enums';


let Tickets = () => {
    let { currentUser, isMobile } = useContext(appUserContext);
    let { isLoading, search, ticketQueues } = useContext(ticketsContext);

    return (
        <>
            {isMobile === false &&
                <Grid container>
                    <Grid item xs={4} sm={3} md={2} style={{ borderRight: `1px solid ${colors.grey[300]}` }}>
                        <Queues />
                    </Grid>

                    <Grid item xs={8} sm={9} md={10}>
                        <PageHeader
                            pageTitle={ticketQueues.getValueByKey(search.ticketQueue, 'name', 'label')}
                            addNewUrl={currentUser.simecClaims.canCreateTicket ? "/ticket/addnew" : undefined}
                        />
                        {search.ticketQueue === TicketQueues.Dashboard &&
                            <>
                                {isLoading === true && <CircleLoader />}
                                {isLoading === false && <Dashboard />}
                            </>
                        }
                        {search.ticketQueue !== TicketQueues.Dashboard &&
                            <>
                                <Filters />
                                {isLoading === true && <CircleLoader />}
                                {isLoading === false && <Results />}
                            </>
                        }
                    </Grid>
                </Grid>
            }
            {isMobile === true &&
                <>
                    <PageHeader
                        pageTitle={ticketQueues.getValueByKey(search.ticketQueue, 'name', 'label')}
                        addNewUrl={currentUser.simecClaims.canCreateTicket ? "/ticket/addnew" : undefined}
                    />
                    <MobileFilters />
                    {isLoading && <CircleLoader />}
                    {isLoading === false &&
                        <>
                            {search.ticketQueue === TicketQueues.Dashboard && <Dashboard />}
                            {search.ticketQueue !== TicketQueues.Dashboard && <MobileResults />}
                        </>
                    }
                </>
            }
        </>
    );
}

export default Tickets;